import { render } from "./VideoPlayerV1.vue?vue&type=template&id=b43508ec&scoped=true"
import script from "./VideoPlayerV1.vue?vue&type=script&lang=js"
export * from "./VideoPlayerV1.vue?vue&type=script&lang=js"

import "./VideoPlayerV1.vue?vue&type=style&index=0&id=b43508ec&scoped=true&lang=css"

import exportComponent from "/Users/oat/WebstormProjects/media_service_test/player/livestream-player/node_modules/.pnpm/vue-loader@17.0.0_webpack@5.72.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b43508ec"]])

export default __exports__